import React, { useState, useEffect } from "react";
import Header from "../../components/header/Header";
import TestimonialsSection from "../../components/testimonialsSection/TestimonialsSection";
import Footer from "../../components/footer/Footer";
import BackToTop from "../../components/backToTop/BackToTop";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    useEffect(() => {
      const filters = document.querySelector(".filters-row");
  
      const handleScroll = () => {
        if (!filters) return;
  
        const offset = filters.getBoundingClientRect().top;
  
        if (offset <= 80) {
          filters.classList.add("stuck");
        } else {
          filters.classList.remove("stuck");
        }
      };
  
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }, []);
  
    useEffect(() => {
      // Scroll to top smoothly when the component mounts / route changes
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant", // or "smooth" if you prefer a gentle scroll
      });
    }, []);

  const handleSectionClick = () => {
    setIsSidebarOpen(false);
  };


  return (
    <>
      <Header
        isMenuOpen={isMenuOpen}
        onMenuToggle={() => setIsMenuOpen(!isMenuOpen)}
      />

      {/* ===== HERO ===== */}
      <section className="legal-hero">
        <div className="legal-container">
          <h1>TUTORSLINKS Privacy Policy</h1>
        </div>
      </section>

      {/* ===== CONTENT ===== */}
      <section className="legal-content-section">
        <div className="legal-container legal-grid">

                      <button
            className="sidebar-toggle"
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          >
            {isSidebarOpen ? "Close Sections" : "View Sections"}
          </button>
          {isSidebarOpen && (
            <div
              className="sidebar-overlay"
              onClick={() => setIsSidebarOpen(false)}
            />
          )}
          {/* ===== SIDEBAR ===== */}
          <aside className="legal-sidebar">
            <a href="#information-collection" onClick={handleSectionClick}>Information We Collect</a>
            <a href="#use-of-information" onClick={handleSectionClick}>How We Use Your Information</a>
            <a href="#data-sharing" onClick={handleSectionClick}>Data Sharing</a>
            <a href="#data-security" onClick={handleSectionClick}>Data Storage & Security</a>
            <a href="#data-retention" onClick={handleSectionClick}>Data Retention</a>
            <a href="#your-rights" onClick={handleSectionClick}>Your Rights</a>
            <a href="#children" onClick={handleSectionClick}>Children’s Privacy</a>
            <a href="#third-party" onClick={handleSectionClick}>Third-Party Links</a>
            <a href="#international" onClick={handleSectionClick}>International Transfers</a>
            <a href="#updates" onClick={handleSectionClick}>Policy Updates</a>
            <a href="#contact" onClick={handleSectionClick}>Contact Us</a>
          </aside>

          {/* ===== MAIN CONTENT ===== */}
          <div className="legal-content">
            <p className="last-updated">Last Updated: 28 February, 2026</p>

            <p>
              TUTORSLINKS (“we,” “our,” or “us”) respects your privacy and is
              committed to protecting the personal information you share with
              us. This Privacy Policy explains how we collect, use, store, and
              protect your data when you use our website, mobile application,
              and related services (collectively referred to as the “Platform”).
            </p>

            <p>
              By using TutorsLinks, you consent to the collection and use of
              your information in accordance with this Policy.
            </p>

            {/* 1 */}
            <section id="information-collection">
              <h2>1. Information We Collect</h2>
              <p>
                We collect information to provide and improve our services. The
                types of information we collect include:
              </p>
              <h3>a. Personal Information</h3>
              <p>Information you provide directly when you:</p>
              <ul>
                <li>Register as a student, tutor, or training centre</li>
                <li>
                  Create or update your profile (name, email, phone, address,
                  qualifications, National ID)
                </li>
                <li>Subscribe to newsletters or promotions</li>
                <li>Make payments or receive payouts</li>
                <li>Communicate with us via email, chat, or phone</li>
              </ul>

              <h3>b. Non-Personal Information</h3>
              <p>
                Automatically collected data when you use the Platform,
                including:
              </p>
              <ul>
                <li>Device type, browser type, operating system</li>
                <li>IP address, geolocation, access times</li>
                <li>Pages visited and actions taken</li>
                <li>Referring website or application</li>
              </ul>

              <h3>c. Payment Information</h3>
              <p>
                If you make or receive payments through TutorsLinks, we collect
                payment details via secure third-party payment processors (e.g.,
                Paystack, Flutterwave). We do not store card or banking details
                on our servers.
              </p>

              <h3>d. Cookies & Tracking Technologies</h3>
              <p>
                We use cookies, web beacons, and analytics tools to improve user
                experience, remember preferences, and analyze usage patterns.
                You can modify your cookie preferences in your browser settings.
              </p>
            </section>

            {/* 2 */}
            <section id="use-of-information">
              <h2>2. How We Use Your Information</h2>
              <p>We use collected data to:</p>
              <ul>
                <li>Create and manage user accounts</li>
                <li>Match students with tutors or centres</li>
                <li>Facilitate communication between users</li>
                <li>Process payments and manage subscriptions</li>
                <li>Personalize user experience and recommendations</li>
                <li>Improve our platform, services, and security. </li>
                <li>
                  Send service updates, notifications, and marketing messages
                  (you can opt out anytime).{" "}
                </li>
                <li>
                  Comply with legal, regulatory, and internal audit
                  requirements.
                </li>
              </ul>
            </section>

            {/* 3 */}
            <section id="data-sharing">
              <h2>3. Data Sharing and Disclosure</h2>
              <p>
                We do not sell your personal data. However, we may share
                information with: :
              </p>
              <ul>
                <li>
                  <strong>Tutors or Students:</strong> To facilitate class
                  bookings or communication.
                </li>
                <li>
                  <strong>Service Providers:</strong> Payment processors,
                  hosting companies, analytics tools, or customer support
                  providers who assist in running our services.
                </li>
                <li>
                  <strong>Regulatory Authorities:</strong> When required by law
                  or legal process
                </li>
                <li>
                  <strong>Business Transfers:</strong> In case of merger,
                  acquisition, or sale of assets, your data may be transferred
                  as part of that transaction.
                </li>
              </ul>
              <p>
                All third parties we engage are required to comply with data
                protection standards equivalent to those in this Policy.
              </p>
            </section>

            {/* 4 */}
            <section id="data-security">
              <h2>4. Data Storage and Security</h2>
              <ul>
                <li>
                  Your personal data is stored securely using encryption and
                  secure cloud servers.{" "}
                </li>
                <li>
                  We adopt technical and organizational measures to prevent
                  unauthorized access, alteration, disclosure, or destruction of
                  data.
                </li>
                <li>
                  While we strive for maximum security, no online system is 100%
                  secure. Users share information at their own risk.
                </li>
              </ul>
            </section>

            {/* 5 */}
            <section id="data-retention">
              <h2>5. Data Retention</h2>
              <p>We retain your information only as long as necessary to:</p>
              <ul>
                <li>Fulfill the purposes outlined in this Policy, or</li>
                <li>Comply with legal or regulatory obligations.</li>
              </ul>
              <p>
                Once your data is no longer needed, it is securely deleted or
                anonymized.
              </p>
            </section>

            {/* 6 */}
            <section id="your-rights">
              <h2>6. Your Rights</h2>
              <p>
                Under the Nigeria Data Protection Act (NDPA) and related laws,
                you have the right to:
              </p>
              <ul>
                <li>Access and obtain a copy of your data.</li>
                <li>Request correction or deletion of inaccurate data.</li>
                <li>Withdraw consent for processing your data. </li>
                <li>Object to processing for marketing purposes. </li>
                <li>Request data portability (transfer of your data).</li>
              </ul>
              <br />
              To exercise any of these rights, contact us at:
              suport@tutorslinks.com
            </section>

            {/* 7 */}
            <section id="children">
              <h2>7. Children’s Privacy</h2>
              <p>
                TutorsLinks is designed for individuals aged 13 and above. For
                users under 18, parental or guardian consent is required before
                account creation or data submission. <br />
                We do not knowingly collect information from minors without
                consent.
              </p>
            </section>

            {/* 8 */}
            <section id="third-party">
              <h2>8. Third-Party Links</h2>
              <p>
                Our platform may contain links to third-party websites or tools.{" "}
                <br />
                We are not responsible for their privacy practices, so please
                review their policies before sharing your data.
              </p>
            </section>

            {/* 9 */}
            <section id="international">
              <h2>9. International Data Transfers</h2>
              <p>
                If we transfer your data outside Nigeria, we ensure adequate
                safeguards are in place to maintain data protection standards
                consistent with NDPA and GDPR principles.
              </p>
            </section>

            {/* 10 */}
            <section id="updates">
              <h2>10. Updates to This Policy</h2>
              <p>
                We may update this Privacy Policy periodically to reflect
                changes in our practices or legal requirements.
                <br />
                The updated version will be posted on our website with the “Last
                Updated” date revised.
              </p>
            </section>

            {/* 11 */}
            <section id="contact">
              <h2>11. Contact Us</h2>
              <p>
                If you have questions, concerns, or complaints regarding this
                Privacy Policy or your personal data, please contact us:
                <br />
                <strong>TUTORSLINKS (Efiko Edutech Ltd.)</strong>
                <br />
                Email: <strong>support@tutorslinks.com</strong>
                <br />
                Phone:
              </p>
            </section>
          </div>
        </div>
      </section>

      {/* TRUST */}
      <section className="trust-section">
        <div className="trust-container">
          <div className="shield-icon">
            <img src="/images/shield-icon.png" alt="Trust" />
          </div>
          <h2>Your Trust Is Our Priority</h2>
          <p>
            Our Tutors are committed to the highest standard of student learning,
            safety, privacy and data protection. Verified tutors and training centres display a verification badge.
          </p>
          <a href="" className="trust-btn">
            Get Started →
          </a>
        </div>
      </section>

      <Footer />
      <BackToTop />
    </>
  );
};

export default PrivacyPolicy;
